




















































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { router } from '@/router';
import FilterComponent from '@/components/filterSimple.vue';
import { projectSimpleService } from '@/services';
import { Export, Operators } from '@/models';
import moment from 'moment';

@Component({
  components: {
    FilterComponent
  }
})
export default class ProjectListPage extends Vue {
  project = this.$store.state.projectSimple;
  application = this.$store.state.application;
  lookup = this.$store.state.lookup;
  account = this.$store.state.account;
  dialog = false;
  exportColumns = Export.projectSimpleColumns;
  allColumns = true;
  startedOnShown = false;
  endedOnShown = false;
  dialogDelete = false;
  searchResponsibleFaculty = '';
  startedOnFilter = {
    value: null,
    operator: 0
  };
  endedOnFilter = {
    value: null,
    operator: 0
  };
  projectToDelete: any = null;

  get headers() {
    const columns: any = [
      { text: this.$t('project.list.projectType'), value: 'projectType', width: '20%', sortable: false },
      { text: this.$t('project.list.name'), value: 'name', width: '20%' },
      { text: this.$t('project.list.responsibleFaculty'), value: 'responsibleFaculty', width: '20%', sortable: false },
      { text: this.$t('project.list.startedOn'), value: 'startedOn', width: '20%' },
      { text: this.$t('project.list.endedOn'), value: 'endedOn', width: '15%' }
    ];

    if (this.isAdmin) {
      columns.push({ text: this.$t('project.list.actions'), value: 'actions', sortable: false, align: 'center' });
    }

    return columns;
  }

  get operators() {
    return Operators.filter.map(item => {
      return { ...item, label: this.$t(`filter.operators.${item.code}`) };
    });
  }

  get projects(): [] {
    return this.$store.getters['projectSimple/getProjects']();
  }

  get totalCount(): [] {
    return this.$store.getters['projectSimple/getTotalCount']();
  }

  get filterValues() {
    const lookups = Object.keys(this.project.simpleSearch.filter)
      .filter((key: string) => (this.project.simpleSearch.filter as any)[key] && key !== 'startedOn' && key !== 'endedOn')
      .map(key => {
        return (this.project.simpleSearch.filter as any)[key].map((item: any) => {
          item.filterName = key;
          return item;
        });
      })
      .flatMap(a => a)
      .map((item: any) => {
        return {
          lookup: this.$store.getters['lookup/getLookupDetail'](item.parentId),
          filterName: item.filterName,
          value: item.value,
          key: item.key
        };
      });

    if (this.project.simpleSearch.filter.startedOn) {
      lookups.push({
        lookup: this.$t('project.list.startedOn'),
        value: `${this.$t(`filter.operators.${this.project.simpleSearch.filter.startedOn.operator}`)} ${moment(String(this.project.simpleSearch.filter.startedOn.value)).format('DD.MM.YYYY')}`,
        filterName: 'startedOn',
        key: 'startedOn'
      });
    }

    if (this.project.simpleSearch.filter.endedOn) {
      lookups.push({
        lookup: this.$t('project.list.endedOn'),
        value: `${this.$t(`filter.operators.${this.project.simpleSearch.filter.endedOn.operator}`)} ${moment(String(this.project.simpleSearch.filter.endedOn.value)).format('DD.MM.YYYY')}`,
        filterName: 'endedOn',
        key: 'endedOn'
      });
    }

    return lookups;
  }

  onPage(page: number): void {
    const el = this.$el.getElementsByClassName('header')[0];

    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }

    this.project.simpleSearch.actualPage = page;
    this.loadProjects();
  }
  onSort(field: any): void {
    this.project.simpleSearch.orderBy = field[0];
    this.loadProjects();
  }
  onSortDesc(desc: any): void {
    this.project.simpleSearch.orderByAsc = !desc[0];
    this.loadProjects();
  }
  onItemsPerPage(field: any): void {
    this.project.simpleSearch.pageRows = field === -1 ? this.project.totalCount : field;
    this.loadProjects();
  }

  created(): void {
    this.loadProjects();
  }

  loadProjects(): void {
    const searchQuery = this.project.simpleSearch;
    this.searchResponsibleFaculty = '';

    this.$store.dispatch('projectSimple/getAll', searchQuery);
  }

  selectProject(event: any): void {
    this.$store.dispatch('projectSimple/clearProject');
    router.push(`/program/${event.id}`);
  }

  setStartedOn() {
    this.project.simpleSearch.filter.startedOn = this.startedOnFilter;
    this.loadProjects();
    this.startedOnShown = false;
  }

  setEndedOn() {
    this.project.simpleSearch.filter.endedOn = this.endedOnFilter;
    this.endedOnShown = false;
    this.loadProjects();
  }

  removeEndedOn() {
    this.endedOnFilter = { operator: 0, value: null };
    this.project.simpleSearch.filter.endedOn = null;
    this.loadProjects();
    this.endedOnShown = false;
  }

  removeStartedOn() {
    this.startedOnFilter = { operator: 0, value: null };
    this.project.simpleSearch.filter.startedOn = null;
    this.loadProjects();
    this.startedOnShown = false;
  }

  setFilter(event: any) {
    this.project.simpleSearch.filter = event;

    this.loadProjects();
  }

  exportToExcel() {
    const columnsToExport = this.allColumns ? null : this.exportColumns.filter(column => column.selected);
    projectSimpleService.exportTo(this.project.simpleSearch, columnsToExport);
    this.dialog = false;
  }

  selectAllColumns() {
    if (this.allColumns) {
      this.exportColumns.forEach(column => {
        column.selected = true;
      });
    }
  }

  columnSelected() {
    this.allColumns = this.exportColumns.filter(column => !column.selected).length === 0;
  }

  clearSelected() {
    this.exportColumns.forEach(column => {
      column.selected = false;
    });

    this.allColumns = false;
  }

  deleteItem(item: any) {
    this.projectToDelete = item;
    this.dialogDelete = true;
  }

  closeDelete() {
    this.projectToDelete = null;
    this.dialogDelete = false;
  }

  deleteItemConfirm() {
    if (this.projectToDelete) {
      this.$store.dispatch('projectSimple/deleteProject', { id: this.projectToDelete.id });
      this.projectToDelete = null;
    }
    this.dialogDelete = false;
  }

  get isAdmin() {
    return this.account.user.user.role === 'Administrator';
  }

  get isExportDisabled() {
    return this.exportColumns.filter(column => column.selected).length === 0;
  }

  async loadItems(id: number) {
    this.$store.dispatch('lookup/getAvailableLookup', id);
  }

  getLookup(id: number) {
    return this.$store.getters['lookup/getAvailableLookupDetail'](id);
  }

  removeFilter(filterName: string, key: string) {
    if (key === 'startedOn') {
      this.removeStartedOn();
    } else if (key === 'endedOn') {
      this.removeEndedOn();
    } else {
      this.project.simpleSearch.filter[filterName] = this.project.simpleSearch.filter[filterName].filter((item: any) => item.key !== key);
      this.loadProjects();
    }
  }
}
